import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getExchangeRates, deleteExchangeRate, viewRates } from "../../actions/exchangeRateActions";
import $ from 'jquery';
import { CircularProgress } from '@material-ui/core';



class ExchangeRateList extends Component {
  constructor() {
    super();
    this.state = {
      buttonState: '',
      errors: {}
    };
    this.addExchangeRate = this.addExchangeRate.bind(this);
    this.editExchangeRate = this.editExchangeRate.bind(this);
    this.deleteExchangeRate = this.deleteExchangeRate.bind(this);
    this.viewRates = this.viewRates.bind(this);
  }

  componentDidMount() {
    this.props.getExchangeRates();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }

    //initialize datatable
    $(document).ready(function () {
      $('#table').DataTable();
    });
  }


  addExchangeRate() {
    this.props.history.push("/add-exchangeRate");
  }
  editExchangeRate(exchangeRateId) {
    this.props.history.push(`/edit-exchangeRate/${exchangeRateId}`);
  }
  viewRates(exchangeRateId) {
    this.setState({ buttonState: "loading" })
    this.props.viewRates(exchangeRateId);
    this.setState({ buttonState: "complete" })
  }

  deleteExchangeRate(exchangeRateId) {
    this.props.deleteExchangeRate(exchangeRateId);
  }

  render() {
    const { errors } = this.state;
    const { exchangeRates } = this.props.exchangeRate;
    const exchangeRateList = exchangeRates.map(exchangeRate => {
      return (
        <tr key={exchangeRate.id}>
           <td>{exchangeRate.date}</td>
          <td>{exchangeRate.currency}</td>
          <td>{exchangeRate.rate}</td>
         

          <td>
            <div className="btn-group float-right">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => this.viewRates(exchangeRate.id)}
              >

                View Rates
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => this.editExchangeRate(exchangeRate.id)}
              >
                Edit
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => this.deleteExchangeRate(exchangeRate.id)}
              >
                Delete
              </button>
            </div>
          </td>
        </tr>
      );
    });

    return (
      <div>
        <div className="container-fluid mt-5">

          <div className="card m-auto  shadow-lg rounded p-3">
            <h1 className="m-auto text-center display-4">Exchange Rate List</h1>
            <p className="lead text-center">List of all exchange rates</p>
            <hr />
            {(errors.message || errors.status) && (
              <div className="alert alert-danger text-center" role="alert">
                {(errors && errors.message) || (errors.statusText && errors.statusText)}

              </div>
            )}

            <div className="d-flex justify-content-center pb-2">
              <button
                className="btn btn-success mt-2"
                onClick={() => this.addExchangeRate()}
              >
                Add Exchange Rate
                </button>
            </div>

            <table id="table" className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Currency</th>
                  <th>Rate</th>
                 <th style={{ textAlign: "right" }}> {this.state.buttonState === "loading" && <CircularProgress />}Actions</th>
                </tr>
              </thead>
              <tbody>{exchangeRateList}</tbody>
            </table>
          </div>

        </div>
      </div>
    );
  }
}
ExchangeRateList.propTypes = {
  getExchangeRates: PropTypes.func.isRequired,
  deleteExchangeRate: PropTypes.func.isRequired,
  viewRates: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  exchangeRate: state.exchangeRate,
  errors: state.errors
});

export default connect(mapStateToProps, { getExchangeRates, deleteExchangeRate, viewRates })(ExchangeRateList);
